import dayjs from "dayjs";
import { daysPerWeek } from "models/common/constants/time";

/**
 * Number of empty cells before loop day 1 in the first row of the
 * calendar-like day grid, so that `startDayIndex` lands on the weekday of
 * `startDate`. Always within `0..daysPerWeek - 1`.
 *
 * `startDayIndex` is 1-based: 1 means day 1 is served on the start date.
 */
// eslint-disable-next-line import/prefer-default-export
export const getLoopDayGridOffset = ({
  startDate,
  startDayIndex,
}: {
  startDate: string | null | undefined;
  startDayIndex: number | null | undefined;
}): number => {
  const startWeekday = dayjs(startDate ?? null).get("day") ?? 0;
  const daysBeforeStart = Math.max((startDayIndex ?? 1) - 1, 0);
  return (
    (((startWeekday - daysBeforeStart) % daysPerWeek) + daysPerWeek) %
    daysPerWeek
  );
};
